"use client";
import Link from "next/link";
import { useTranslation } from "react-i18next";

export default function NotFoundContent() {
  const { t, i18n } = useTranslation();
  // TranslationsProvider ya lo deja en uno de los 7 idiomas, aunque la URL traiga otro.
  const ln = i18n.language;

  // data-bcm-404: el pixel de Meta y el tag de Google Ads no mandan el PageView acá
  // (lib/es404.js).
  return (
    <div className="container position-relative pt-100 pb-100" data-bcm-404="">
      <title>404 - BCM</title>
      <div className="row">
        <div className="col-12 align-center">
          <p className="mb-10 mt-20" style={{ fontSize: 64, fontWeight: 700, lineHeight: 1 }}>
            404
          </p>
          <h1 className="mb-20" style={{ fontSize: 26, fontWeight: 700 }}>
            {t("not_found_page.title")}
          </h1>
          <p className="fs-6 mb-30" style={{ maxWidth: 540, margin: "0 auto 30px" }}>
            {t("not_found_page.text")}
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Link
              href={`/${ln}/libros`}
              className="btn btn-mod btn-circle btn-large"
              data-btn-animate="y"
            >
              {t("not_found_page.books")}
            </Link>
            <Link
              href={`/${ln}`}
              className="btn btn-mod btn-border btn-circle btn-large"
              data-btn-animate="y"
            >
              {t("not_found_page.home")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
